module.exports = __webpack_public_path__ + "assets/images/officeBuilding-03.1f61d28c9a789aab6eac2004d19ba3ed.svg";